<template>
  <div class="relogin-on-fly noHideSidebar">
    <div class="relogin-on-fly__ie-blur"></div>
    <ui-scrollbar>
    <div class="relogin-on-fly__content-wrapper">
      <div class="relogin-header">
        <div class="relogin-header__container">
          <div class="relogin-header__logo">
            <img class="relogin-header__logo-img" srcset="static/img/logo.png 1x, static/img/logo@2x.png 2x"  src="static/img/logo.png"  :alt="$t('common.title')">
            <div class="relogin-header__logo-text" v-html="$t('common.title')" /> 
          </div>
        </div>
      </div>
      <div class="relogin-content">
        <div class="relogin-on-fly__inner">
          <div class="relogin-on-fly__notify">
            <div class="relogin-on-fly__icon">
              <img src="static/img/lock.svg" alt="icon">
            </div>
            Вас долго не было и мы, ради сохранения безопасности, завершили рабочую сессию. Если закрыть это окно несохраненные изменения будут   утеряны. Для продолжения работы авторизуйтесь в системе.
          </div>
          <div class="relogin-on-fly__alert" :class="alertType" v-if="alertText">
            {{alertText}}
          </div>
          <div class="relogin-on-fly__form-container">
            <div class="relogin-on-fly__legend">
              <span v-if="!validationError && !notificationText">{{ $t('login.students_login') }}</span>
              <span v-else-if="validationError" class="login-page-form__error">{{ validationError }}</span>
              <span v-else class="relogin-on-fly__notification">{{ notificationText }}</span>
            </div>
            <authenticate
              @login-success="onLoginSuccess"
              @login-error="onLoginError"
              @login-canceled="onLoginCancel"
              @getError="showError"
              @recoveryCodeSended="onRecoveryCodeSended"
              @passwordChanged="onPasswordChanged"
              :show-cancel="false"
            >
            </authenticate>
          </div>
        </div>
      </div>
      <div class="relogin-footer">
        <div class="relogin-footer__wrapper">
          <div class="relogin-footer__container">
            <a href="#" class="relogin-footer__logo">
              <img srcset="static/img/logo-sechenov-light.png 1x, static/img/logo-sechenov-light@2x.png 2x "  src="static/img/logo-sechenov-light.png" alt="Сеченовский университет">
            </a>
            <!--<div class="relogin-footer__link">
              <div class="relogin-footer__link-title">
                Информация
              </div>
              <a href="#" class="relogin-footer__link-link">
                О проекте
              </a>
            </div>
            <div class="relogin-footer__link">
              <div class="relogin-footer__link-title">
                Служба тех.поддержки
              </div>
              <a href="#" class="relogin-footer__link-link">
               support.doc@ya.ru
             </a>
            </div>
            <div class="relogin-footer__link">
              <div class="relogin-footer__link-title">
                {{ $t('labels.enter') }}
              </div>
              <a href="#" class="relogin-footer__link-link">
                для пациентов
              </a>
            </div>-->
            <a :href="technologyLink" class="relogin-footer__logo-ldp" target="_blank">
             <div class="relogin-footer__logo-ldp-container">
               <img src="static/img/ldp-logo_lion.svg" alt="Lions Digital Pro" class="relogin-footer__logo-ldp-image">
               <div class="relogin-footer__logo-ldp-text-container">
                 <div class="relogin-footer__logo-ldp-text">{{ $t('login.work_tech') }}</div>
                 <img src="static/img/ldp-logo_text.svg" alt="Lions Digital Pro" class="relogin-footer__logo-ldp-name">
               </div>
             </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    </ui-scrollbar>
  </div>
</template>

<script>
  import Authenticate from 'src/components/Authenticate/Authenticate.vue'
  import config from '@/config'
  import { CONF_TECHNOLOGY_LINK } from '@/constants'

  export default {
    name: 'ReloginOnFly',
    components: {
      Authenticate
    },
    computed: {
      technologyLink() {
        return config(CONF_TECHNOLOGY_LINK) || 'https://lionsdigital.pro';
      }
    },
    data () {
      return {
        validationError: '',
        alertText: '',
        alertType: 'success',
        notificationText: ''
      }
    },
    methods: {
      onRecoveryCodeSended () {
        this.notificationText = 'Вам на почту отправлен код восстановления пароля';
      },
      onPasswordChanged () {
        this.alertText = 'Пароль успешно изменен';
      },
      onLoginCancel () {
        // Для родителя, чтобы закрыл данный компонент
        this.$emit('login-canceled')
        // Для сервиса auth
        this.$bus.$emit('relogin-on-fly:canceled', 'cancel')
      },
      onLoginError () {
        // Для сервиса auth
        this.$bus.$emit('relogin-on-fly:error')
      },
      onLoginSuccess (token) {
        // Для родителя, чтобы закрыл данный компонент
        this.$emit('login-success')
        // Для сервиса auth
        this.$bus.$emit('relogin-on-fly:success', token)

        // Для DashboardLayout, что бы обновил инфу о юзере
        this.$bus.$emit('userInfoUprate')
        // фокус на контенте для работы pageUp...
        this.$root.$emit('focusOnContent')
      },
      updateSidebar () {
        // Обновить инфорамцию в сайдбаре
      },
      showError (err) {
        this.validationError = err;
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/sass/core";

$screen-sm:           768px;
$screen-md:           992px;
$screen-lg:           1200px;
$max-container-width: $screen-lg;

.relogin-on-fly {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  background: rgba(57, 124, 255, 0.2);
  .bz-scrollbar__content--wrapper {
    display: flex;
    flex-direction: column;
  }

  &__content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  &__ie-blur {
    // display: none;
    position: absolute;
    opacity: .7;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(236.84deg, rgba(46, 49, 146, 0.5) 26.87%, rgba(47, 128, 237, 0.5) 82.02%);
  }

  &__inner {
    z-index: 1;
    position: relative;
    max-width: 460px;
    padding: 50px 15px;
  }

  &__form-container {
    position: relative;
    z-index: 1;
    background: #fff;
    border-radius: 4px;
  }

  &__alert {
    background: #CEF2DB;
    padding: 25px 60px;
    font-size: 14px;
    color: #15BF51;
    margin-bottom: 10px;
    border-radius: 4px;
  }

  &__notify {
    position: relative;
    margin-bottom: 15px;
    padding: 24px 20px 25px 100px;
    background: #FEEDC2;
    box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 15px;
    line-height: 1.3;
    color: #F3AF37;

    @media only screen and (min-width: $screen-sm){
      padding: 24px 60px 25px 100px;
    }
  }

  &__icon {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 24px;
    left: 30px;
    border-radius: 100%;
    text-align: center;
    background-color: rgba(242, 180, 72, 0.31);
  }

  .form {
    padding: 0 20px 30px 20px;
    @media only screen and (min-width: $screen-sm){
      padding: 0 60px 30px 60px;
    }
  }

  &__legend {
    padding: 20px;
    color: #2B2927;
    font-size: 20px;
    font-weight: 700;

    @media only screen and (min-width: $screen-sm){
      padding: 30px 60px 44px 60px;
      font-size: 24px;
    }
  }

  &__notification {
    display: block;
    width: 100%;
    padding: 10px 20px;
    border-radius: 2px;
    background: #CEF2DB;
    font-size: 12px;
    font-weight: 400;
    color: #15BF51;

    @media only screen and (min-width: $screen-sm){
      margin-top: 0;
    }
  }

  &__error {
    display: block;
    width: 100%;
    padding: 10px 20px;
    border-radius: 2px;
    background: #FF5656;
    font-size: 12px;
    font-weight: 400;
    color: #fff;

    @media only screen and (min-width: $screen-sm){
      margin-top: 0;
    }
  }
}

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter {
  opacity: 0;
}

.relogin-header {
  height: 75px;
  width: 100%;
  z-index: 1;
  position: relative;
  background: #fff;

  &__container {
    display: flex;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    padding: 0 25px;

    @media only screen and (min-width: $screen-lg) {
      max-width: $max-container-width;
      margin: 0 auto;
    }
  }

  &__logo {
    height: 100%;
    display: flex;
    align-items: center;
  }

  &__logo-img {
    margin-right: 21px;
  }

  &__logo-text {
    display: inline-block;
    margin: 0;
    padding-left: 18px;
    font-weight: 700;
    font-size: 24px;
    color: #1E5A9F;
    border-left: 1px solid rgba(30, 90, 159, .5);
  }
}

.relogin-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.relogin-footer {
  width: 100%;
  position: relative;
  z-index: 1;

  &__wrapper {
    @media only screen and (min-width: $screen-lg) {
      height: 100%;
      max-width: $max-container-width;
      margin: 0 auto;
      padding: 0 25px;
    }
  }

  &__container {
    display: grid;
    align-items: center;
    grid-template-areas:
    "logo"
    "link-1"
    "link-2"
    "link-3"
    "logo-ldp";
    border-top: 1px solid rgba(252, 252, 252, .2);

    @media only screen and (min-width: $screen-sm) {
      grid-template-areas:
      "link-1 link-2 link-3"
      "logo . logo-ldp";
    }

    @media only screen and (min-width: $screen-md) {
      grid-template-areas:
      "logo link-1 link-2 link-3 logo-ldp";
    }
  }

  &__logo {
    grid-area: logo;
    display: block;
    padding: 25px 0 25px 25px;

    @media only screen and (min-width: $screen-lg) {
      padding-left: 0;
    }
  }

  &__link {
    padding: 0 0 25px 25px;

     @media only screen and (min-width: $screen-sm){
       border-bottom: 1px solid rgba(252, 252, 252, .2);
       padding: 25px 0 25px 25px;
     }

     @media only screen and (min-width: $screen-md){
       border-bottom: none;
     }

     @media only screen and (min-width: $screen-lg) {
       padding-left: 0;
     }

     //1-й линк
     &:nth-of-type(2){
       grid-area: link-1;
     }

     //2-й линк
     &:nth-of-type(3){
       grid-area: link-2;
     }

     //3-й линк
     &:nth-of-type(4){
       grid-area: link-3;
     }
  }

  &__link-title {
    opacity: .5;
    font-size: 10px;
    color: #fff;
    font-weight: 400;
  }

  &__link-link {
    font-size: 21px;
    font-weight: 700;
    color: #fff;
    line-height: 1;

    &:hover {
      opacity: .8;
      color: #fff;
    }
  }

  &__logo-ldp {
    grid-area: logo-ldp;
    display: block;
    padding: 25px 0 25px 25px;
    border-top: 1px solid rgba(252, 252, 252, .2);

    @media only screen and (min-width: $screen-sm) {
      border-top: none;
    }

    @media only screen and (min-width: $screen-lg) {
      justify-self: end;
      padding-left: 0;
    }
  }

  &__logo-ldp-container {
    display: flex;
  }

  &__logo-ldp-image {
    margin-right: 13px;
  }

  &__logo-ldp-text {
    opacity: .5;
    font-size: 10px;
    color: #fff;
    font-weight: 400;
  }
}
</style>